var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: _vm.file.categoria
          ? "Timeline del Expediente # " +
            _vm.file.categoria +
            "-" +
            _vm.file.numeroExt
          : "Timeline del Expediente " + _vm.file.numero,
        "hide-footer": "",
        centered: ""
      },
      on: { close: _vm.closeModal },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    _vm._l(_vm.timelineFile, function(node, index) {
      return _c(
        "vs-collapse",
        { key: index },
        [
          _c(
            "vs-collapse-item",
            { attrs: { open: "" } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v(" " + _vm._s(node.usuarioEnvioNombre) + " - "),
                _c("small", [
                  _vm._v(_vm._s(_vm._f("dateFormatTime")(node.fechaCreacion)))
                ])
              ]),
              _c(
                "vs-list",
                _vm._l(node.destinatarios, function(subject, index) {
                  return _c(
                    "vs-list-item",
                    {
                      key: index,
                      staticClass: "wrap-item",
                      attrs: {
                        icon: _vm.getIcon(subject),
                        title: subject.destinoListaNombre,
                        subtitle: subject.comentario
                      }
                    },
                    [
                      subject.estado === 1
                        ? _c(
                            "span",
                            {
                              staticClass: "active-subject",
                              attrs: { title: "Activo" }
                            },
                            [
                              _c("vs-icon", {
                                staticStyle: { padding: "4px" },
                                attrs: {
                                  icon: "radio_button_checked",
                                  color: "green",
                                  round: "",
                                  bg: "#92de9266"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      subject.estado === 2
                        ? _c(
                            "span",
                            { attrs: { title: "Inactivo" } },
                            [
                              _c("vs-icon", {
                                staticStyle: { padding: "4px" },
                                attrs: {
                                  icon: "radio_button_unchecked",
                                  color: "orange",
                                  round: "",
                                  bg: "#ffb1004f"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      subject.tipoDestino === 1
                        ? _c(
                            "vs-chip",
                            { attrs: { transparent: "", color: "primary" } },
                            [_vm._v(" Destino ")]
                          )
                        : _vm._e(),
                      subject.tipoDestino === 2
                        ? _c(
                            "vs-chip",
                            { attrs: { transparent: "", color: "#43C3B9" } },
                            [_vm._v(" Copia ")]
                          )
                        : _vm._e(),
                      _c("vs-chip", [
                        _vm._v(" " + _vm._s(subject.destinoNombre) + " ")
                      ])
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }